import { css } from '@emotion/react';

import * as React from 'react';
import { useEffect } from 'react';

import { Grid } from '@coursera/cds-core';

import { trackSpentTime, trackStaffPermissionsPageViewEvent } from '../utils/eventingUtils';
import { AdminUserProfilesData } from './StaffPermissionsData/AdminUserProfilesData';
import { AdminUserRolesData } from './StaffPermissionsData/AdminUserRolesData';
import { useStaffPermissionsEventing } from './StaffPermissionsEventing';
import UserCardContainer from './UserCardContainer';
import UserTableView from './UserTableView';

const styles = {
  contentContainer: () => css`
    margin: var(--cds-spacing-600) var(--cds-spacing-300) 0 var(--cds-spacing-300);

    /* empirical value based on the layout variable from bundles/authoring/styles/layout.styl */
    max-width: 960px;
  `,
};

export type Props = {
  partnerId: number | string;
  userId: number | string;
};

const UserRoleView = ({ partnerId, userId }: Props) => {
  const {
    eventData,
    ingressPointScopeData,
    targetUserId,
    staffPermissionsViewLoadedTime,
    setStaffPermissionsViewLoadedTime,
  } = useStaffPermissionsEventing();

  useEffect(() => {
    if (!!eventData && !!ingressPointScopeData && !!targetUserId) {
      trackStaffPermissionsPageViewEvent(eventData, ingressPointScopeData, Number(targetUserId));
    }
    // mark the timestamp that this component is loaded
    const loadedTime = Date.now();
    if (!staffPermissionsViewLoadedTime) {
      setStaffPermissionsViewLoadedTime(loadedTime);
    }

    // track spent time inside the component upon exit
    return () => {
      if (!!eventData && !!targetUserId) {
        trackSpentTime(eventData, Date.now() - loadedTime, Number(targetUserId));
      }
    };
    // the side effect of eventing is intended to be executed only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid css={styles.contentContainer}>
        <AdminUserProfilesData userId={userId}>
          <UserCardContainer />
        </AdminUserProfilesData>
        <AdminUserRolesData partnerId={partnerId} userId={userId}>
          <UserTableView />
        </AdminUserRolesData>
      </Grid>
    </Grid>
  );
};

export default UserRoleView;
